import { ComponentRef, Directive, ViewContainerRef } from '@angular/core';
import { ToastComponent } from 'app/controls/toast/toast.component';

import { ActionBarComponent } from './action-bar.component';

@Directive({
    selector: '[action-bars]',
    standalone: false
})
export class ActionBarDirective {
  constructor(private viewContainerRef: ViewContainerRef) { }

  public createComponent(): ActionBarComponent
  {
    const componentRef =
        this.viewContainerRef.createComponent(ActionBarComponent);
    const component = componentRef.instance;
    component.componentRef = componentRef;
    const loaderComponentElement = component.nativeElement;
    const parent: Node = loaderComponentElement.parentNode;
    parent.insertBefore(loaderComponentElement, parent.firstChild);
    return component;
  }

  public createToast(): ComponentRef<ToastComponent>
  {
    const componentRef =
        this.viewContainerRef.createComponent(ToastComponent);
    document.body.appendChild(componentRef.location.nativeElement);
    return componentRef;
  }
}
